import * as types from './actionTypes';
import { NotificationDescription, NotificationProps, NotificationType } from './util';

export const showInfoNotification = (props?: NotificationProps) => {
    return {
        type: types.TOGGLE_NOTIFICATION,
        visible: true,
        notificationType: NotificationType.Info,
        message: props?.message,
        description: props?.description,
        duration: props?.duration,
        placement: props?.placement
    } as types.ToggleNotificationAction;
};

export const showSuccessNotification = (props?: NotificationProps) => {
    return {
        type: types.TOGGLE_NOTIFICATION,
        visible: true,
        notificationType: NotificationType.Success,
        message: props?.message,
        description: props?.description,
        duration: props?.duration,
        placement: props?.placement
    } as types.ToggleNotificationAction;
};

export const showErrorNotification = (props?: NotificationProps) => {
    return {
        type: types.TOGGLE_NOTIFICATION,
        visible: true,
        notificationType: NotificationType.Error,
        message: props?.message,
        description: props?.description,
        duration: props?.duration,
        placement: props?.placement
    } as types.ToggleNotificationAction;
};

export const showWarningNotification = (props?: NotificationProps) => {
    return {
        type: types.TOGGLE_NOTIFICATION,
        visible: true,
        notificationType: NotificationType.Warning,
        message: props?.message,
        description: props?.description,
        duration: props?.duration,
        placement: props?.placement
    } as types.ToggleNotificationAction;
};

export const showNotification = (desc: NotificationDescription) => {
    return {
        type: types.TOGGLE_NOTIFICATION,
        ...desc,
    } as types.ToggleNotificationAction;
};

export const hideAllNotification = () => {
    return {
        type: types.TOGGLE_NOTIFICATION,
        visible: false,
        notificationType: NotificationType.Info, // just dummy type
    } as types.ToggleNotificationAction;
};